import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'
import React, { useRef, useEffect, useState } from 'react'
import katex from 'katex'
import {getSelectionCoords} from "@/utils";
import {APP_WEB} from "@/electron_interactive";


export default (props) => {
  const { node } = props;
  let latexBlockRef = useRef(null);
  const [metaData, setMetaData] = useState('');
  const [latexHtmlData, setLatexHtmlData] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  //显示
  const showLatexBlock = (x,y)=>{
    node.attrs.firstCreate = false;
    window.showPopupLatexBlock(props,x,y,node.attrs.metaData,(szContent:any)=>{
      // 实时更新html latex数据
      let html = katex.renderToString(szContent.replace(/\\begin{align\*?}/g, '\\begin{aligned}').replace(/\\end{align\*?}/g, '\\end{aligned}'), {
        throwOnError: false
      })
      setLatexHtmlData(html)
      if (window.isEdited === 1) {
        window.isEdited = 2
      }
      // 将latex格式数据存储到 data-metaData 中
      node.attrs.metaData = szContent;

      console.log('node.attrs.metaData:'+node.attrs.metaData)
    });
  }

  //点击
  const handleClick = (event:any) => {
    if (APP_WEB)return;
    let x = event.pageX;
    let y = event.pageY;
    x = x - event.nativeEvent.offsetX;
    y -= event.nativeEvent.offsetY;
    y += 42;

    showLatexBlock(x,y)
  };

  const getBackgroundColor = () => {
    if (isSelected) {
      return 'var(--card-latex-block-background-hover-color)'
    }
    if (isHovered) {
      return 'var(--card-latex-block-background-hover-color)';
    }
    // return node.attrs?.metaData?.trim() === '' ? '#ebebeb' : '#fff';
    return 'var(--card-latex-block-background-color)'
  };


  useEffect(() => {
    // // 初始化html latex
    let html = katex.renderToString(node.attrs.metaData.replace(/\\begin{align\*?}/g, '\\begin{aligned}').replace(/\\end{align\*?}/g, '\\end{aligned}'), {
      throwOnError: false
    })
    setLatexHtmlData(html)
    if (node.attrs.firstCreate){
      const pos = getSelectionCoords(window);
      showLatexBlock(pos.x,pos.y+40);
    }
    return () => {
    }
  }, [])

  return (
      <>
        <NodeViewWrapper className='latexBlock' ref={latexBlockRef} data-id={node.attrs.id} style={{ display: node.attrs.ifhidden ? 'none' : 'block' }}>
          <div
              className='htmlLatex'
              contentEditable={false}
              onClick={handleClick}
              style={{textAlign: 'center', backgroundColor: getBackgroundColor(),borderRadius:'8px'}}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              // dangerouslySetInnerHTML={{__html: node.attrs?.metaData?.trim() === '' ? `<div style='color:#d2d2d2'>Add a Tex equation</div>` : latexHtmlData}}
          >
            <span style={{pointerEvents:'none',whiteSpace:'pre',overflowWrap:'anywhere'}} dangerouslySetInnerHTML={{__html: node.attrs?.metaData?.trim() === '' ? `<div style='color:#d2d2d2'>Add a Tex equation</div>` : latexHtmlData}}>

            </span>
          </div>

          {/*<div className='popup' contentEditable={false} onBlur={handleBlur}>*/}
          {/*  <textarea*/}
          {/*      value={metaData}*/}
          {/*      onChange={handleChange}*/}
          {/*      id="input" className="input" placeholder="Enter Latex"*/}
          {/*      onKeyDown={handleKeyDown}*/}
          {/*  ></textarea>*/}
          {/*  <button id="doneBtn" className="done-btn" onClick={inputDone}>Done</button>*/}
          {/*</div>*/}

        </NodeViewWrapper>
      </>

  )
}